import { render, staticRenderFns } from "./h3-textarea.vue?vue&type=template&id=ac34fdd4&scoped=true&"
import script from "./h3-textarea.vue?vue&type=script&lang=ts&"
export * from "./h3-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./h3-textarea.vue?vue&type=style&index=0&id=ac34fdd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac34fdd4",
  null
  
)

export default component.exports